/**
* Testimonial Slider Single JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial Slider Single component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial-slider-single',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.testimonial-slider-single.splide' ).each( function( index, slide ) {
        const splide = new Splide( slide, {
          type: 'slide',
          perPage: 1,
          perMove: 1,
          gap: '1rem',
          pagination: false,
          drag: false,
          live: true,
        } );

        splide.on( 'overflow', function( isOverflow ) {
          splide.options = {
            arrows: isOverflow,
          };
        } );

        splide.on( 'visible', function( e ) {
          $( e.slide ).find( '.splide-slide' ).attr( 'tabindex', '0' );
        } );

        splide.on( 'hidden', function( e ) {
          $( e.slide ).find( '.splide-slide' ).removeAttr( 'tabindex' );
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial-slider-single', COMPONENT );
} )( app );
